import { Stripe, StripeElements } from "@stripe/stripe-js";
import { BillingContact, TransactionPaymentMethod } from "../models/transaction.models";
import { getCountryCode } from "../shared/address";

export const createStripePaymentMethod = async (stripe: Stripe|null, elements: StripeElements|null, billingContact: BillingContact) => {
	if (stripe === undefined || stripe === null || elements === undefined || elements === null)
		return null;

	let cardElement = elements?.getElement("card");
			
	if (cardElement === null || cardElement === undefined)
		return null;
	
	let paymentMethodResult = await stripe?.createPaymentMethod({
		card: cardElement,
		type: "card",
		billing_details: {
			name: billingContact.FirstName + ' ' + billingContact.LastName,
			email: billingContact.Email,
			phone: billingContact.HomePhone || billingContact.MobilePhone,
			address: {
				line1: billingContact.Address?.Street1,
				line2: billingContact.Address?.Street2,
				city: billingContact.Address?.City,
				state: billingContact.Address?.Province,// ?? selectedBillingContact.Address?.Region,
				postal_code: billingContact.Address?.PostalCode,

				country: getCountryCode(billingContact.Address?.Country ?? "")
			}
		}
	});

	if (paymentMethodResult.error)
		return null;

	return paymentMethodResult.paymentMethod;
}

export const getTransactionPaymentMethodDescription = (paymentMethod: TransactionPaymentMethod|undefined) => {
	switch (paymentMethod) {
		case TransactionPaymentMethod.DepositOnline:
			return "Stripe Online (Deposit)";
		case TransactionPaymentMethod.FullAmountOnline:
			return "Stripe Online (Paid in full)";
		case TransactionPaymentMethod.PhoneFollowUp:
			return "Phone Follow-Up";
		case TransactionPaymentMethod.ManualStripe:
			return "Stripe (Staff Processed)";
		case TransactionPaymentMethod.OfflineCash:
			return "Cash";
		case TransactionPaymentMethod.OfflineDebit:
			return "Debit Card";
		case TransactionPaymentMethod.OfflineCredit:
			return "Credit Card";
		default:
			return "Unknown Payment Method";
	}
}